export default __webpack_public_path__ + "static/media/Untitled.b0487c32.png";